// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Image-module--image-container--jOq4I","info":"Image-module--info--3a7ol"};